/* eslint-disable @typescript-eslint/no-explicit-any */

import { includes } from 'es-toolkit/compat';
export function getRequiredMarkerIfNeeded(
  requiredFields: string[],
  field: ReduxFormField<any>,
  marker = ' *'
): string {
  return includes(requiredFields, field.name) ? marker : '';
}
